import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatIconModule } from "@angular/material/icon";
import { NgbNavModule } from '@ng-bootstrap/ng-bootstrap';
import { Select2Module } from "src/app/shared/ui/forms/inputs/oops-select2/select2.module";
import { UiModule } from 'src/app/shared/ui/ui.module';

import { FormOfPaymentTypeSelectionComponent } from './form-of-payment-type-selection.component';

@NgModule({
    declarations: [
        FormOfPaymentTypeSelectionComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        MatIconModule,
        NgbNavModule,
        Select2Module,
        UiModule
    ],
    exports: [
        FormOfPaymentTypeSelectionComponent
    ]
})
export class FormOfPaymentTypeSelectionModule { }